module.exports = __webpack_public_path__ + "img/d886035.jpg";